window.brodos = window.brodos || {};
window.storeShip = window.storeShip || {};
brodos.storeShip = brodos.storeShip || {};
storeShip = storeShip || {};
var currentUrl = window.location.href;
var splitedUrl = currentUrl.split("/");
brodos.storeShip.path = splitedUrl[0]+'//www.storeship.com/storeship';
storeShip.path = splitedUrl[0]+'//www.storeship.com/storeship';
function render(id, content) {
    content = content.substring(1, content.length - 1);
    document.getElementById(id).innerHTML = content;
    var autoCompleteId = "_storeship_autocomplete_"+id;
    if(document.getElementById(autoCompleteId)){
        new google.maps.places.Autocomplete(document.getElementById(autoCompleteId));
    }
}
brodos.storeShip.appendJS = function(url,patternToCheck){
    if(patternToCheck){
        var scriptTags = document.getElementsByTagName('script');
        for(scriptTag in scriptTags){
            var scriptTagObj =scriptTags[scriptTag];		
            if(scriptTagObj.src!=undefined){
                if(patternToCheck.test(scriptTagObj.src)){
                    return;
                }
            }
        }
    }
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;    
    head.appendChild(script);
};
brodos.storeShip.order = function(options) {
    var query = brodos.storeShip.toQueryString(options); 
    brodos.storeShip.param = query;
    var custombutton_url = brodos.storeShip.path + '/custombutton/customwebshopbutton?' + query;
    brodos.storeShip.appendJS(custombutton_url,'');
    if(options.location!=undefined && options.location=="true"){
        var customlocation_url = brodos.storeShip.path+'/js/libraries/integration/customLocation.js';        
        var patterToCheck = /\/js\/libraries\/integration\/customLocation.js/;
        brodos.storeShip.appendJS(customlocation_url,patterToCheck);
    }    
};
brodos.storeShip.toQueryString = function(object) {
    var paramObjects = [], params = [], i, j, ln, paramObject, value;
    for (i in object) {
        if (object.hasOwnProperty(i)) {
            paramObjects = paramObjects.concat({name: i, value: object[i]});
        }
    }
    for (j = 0, ln = paramObjects.length; j < ln; j++) {
        paramObject = paramObjects[j];
        value = paramObject.value;
        params.push(encodeURIComponent(paramObject.name) + '=' + encodeURIComponent(String(value)));
    }
    for (j = 0, ln = object.length; j < ln; j++) {
        params.push(encodeURIComponent(object[j].name) + '=' + encodeURIComponent(String(value)));
    }
    params.push('ref=' + encodeURIComponent(location.href));
    return params.join('&');
};
storeShip.button = brodos.storeShip.order;
storeShip.toQueryString = brodos.storeShip.toQueryString;
define("store-ship", function(){});

